import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class EnvService {
	public service_host = 'deldshbtestdbs.alteram.co.za';

	public whhost = 'deldshbtestwhs.alteram.co.za';
	public dbhost = 'deldshbtestdbs.alteram.co.za';
	public ddshost = 'deldshbtestdds.alteram.co.za';
	public schedulerhost = 'deldshbtestbatch.alteram.co.za';

	public dbport = 4892;
	public whport = 4893;
	public ddsport = 4894;
	public schedulerport = 4896;

	public wh_service_url = 'https://' + this.whhost;
	public db_service_url = 'https://' + this.dbhost;
	public dds_service_url = 'https://' + this.ddshost;
	public scheduler_service_url = 'https://' + this.schedulerhost;

	public dds_server_active = true;
	public max_records = 100;

	public isAdmin = true;
     
        public cache_service = ['/whapi/all_ao_map','/whapi/getTableColumns']; // (New Variable)


	public skip_spinner_for_services = [
		'/whapi/getTableColumns',
		'/get_all_tables_and_columns',
		'/get_pipeline_instance_logs',
                '/whapi/job/data',
                '/whapi/all_ao_map',
                '/auth',
                '/api/get_user_role_map'
	];
	public services_to_skip = [ '/auth' ];

	public io_host = 'deldshbtest.alteram.co.za';
	public io_port = '3001';
	public io_namespace = 'test';
	public io_url = 'https://' + this.io_host + ':' + this.io_port + '/' + this.io_namespace;

	public css_theme = 'basic';

	public external_btn_conf_cases = [
        {
            value_value: 'view_task',
            value_name: 'view_task'
        },
        {
            value_value: 'view_meeting',
            value_name: 'view_meeting'
        },
		{
			value_value: 'view_case',
			value_name: 'view_case'
		}
    ];


public system_access_options = [
    {
      value_value: 'Config Access',
      value_name: 'Config Access'
    },
    {
      value_value: 'Internal App',
      value_name: 'Internal App'
    },
    {
      value_value: 'External App',
      value_name: 'External App'
    }
  ];

  public holiday_type = [
    {
      value_value: 'Weekend',
      value_name: 'Weekend'
    },
    {
      value_value: 'Public',
      value_name: 'Public'
    }
  ]


 public  raptor_switch = true;

 public max_query_history_length = 50;

 public scheduler_type = [
  {
    value_value: 'Always',
    value_name: 'Always'
  },
  {
    value_value: 'OnSuccess',
    value_name: 'OnSuccess'
  }
]

public dynamic_filter_options = [
    {
      'value_name': 'Dynamic Date',
      'value_value': 'Dynamic Date',
      'data':  [
        { key: "Today", value: "Today" },
        { key: "Yesterday", value: "Yesterday" },
        { key: "Tommorrow", value: "Tommorrow" },
        { key: "Current Month Start", value: "Current Month Start" },
        { key: "Current Month End", value: "Current Month End" },
        { key: "Next Month Start", value: "Next Month Start" },
        { key: "Previous Month Start", value: "Previous Month Start" },
        { key: "Previous Month End", value: "Previous Month End" },
        { key: "Current Year", value: "Current Year" },
        { key: "Current Month", value: "Current Month" },
        { key: "Previous Year", value: "Previous Year" },
        { key: "Previous Month", value: "Previous Month" },
        { key: "Next Year", value: "Next Year" },
        { key: "Next Month", value: "Next Month" },
        { key: "Last 3 Months", value: "Last 3 Months" }
      ],
      'input_type': 'Date'
    },
    {
      'value_name': 'Dynamic Year',
      'value_value': 'Dynamic Year',
      'data': [
        { key: "Current Year Value", value: "Current Year" },
        { key: "Previous Year Value", value: "Previous Year" },
        { key: "Next Year Value", value: "Next Year" }
      ],
      'input_type': 'Text'
    },
    {
      'value_name': 'Dynamic Month',
      'value_value': 'Dynamic Month',
      'data': [
        { key: "Current Month Name", value: "Current Month" },
        { key: "Previous Month Name", value: "Previous Month" },
        { key: "Next Month Name", value: "Next Month" },
        { key: "Month Start", value: "Month Start"},
        { key: "Month End", value: "Month end"}
      ],
      'input_type': 'Dropdown'
    },
    {
      'value_name': 'Dynamic Month Number',
      'value_value': 'Dynamic Month Number',
      'data': [
        { key: "Current Month Number", value: "Current Month Number" },
        { key: "Previous Month Number", value: "Previous Month Number" },
        { key: "Next Month Number", value: "Next Month Number" },
        { key: "Month Start Number", value: "Month Start Number"},
        { key: "Month End Number", value: "Month end Number"}
      ],
      'input_type': 'Dropdown'
    },
    {
      'value_name': 'Dynamic Monthly Week',
      'value_value': 'Dynamic Month Week',
      'data': [
        { key: "Current Week of Month", value: "Current Week of Month" },
      ],
      'input_type': 'Dropdown'
    },
    {
      'value_name': 'Dynamic Yearly Week',
      'value_value': 'Dynamic Yearly Week',
      'data': [
        { key: "Current Week of Year", value: "Current Week of Year" }
      ],
      'input_type': 'Dropdown'
    },
    {
      'value_name': 'Dynamic Week',
      'value_value': 'Dynamic Week',
      'data': [
        { key: "Weekday Name Yesterday", value: "Yesterday" },
        { key: "Weekday Name Today", value: "Today" },
        { key: "Weekday Name Tomorrow", value: "Tomorrow" },
        { key: "Weekday Name Start Day", value: "Week Start Day" },
        { key: "Weekday Name End Day", value: "Week End Day" },
      ],
      'input_type': 'Dropdown'
    },
    {
      'value_name': 'Dynamic Full Week',
      'value_value': 'Dynamic Full Week',
      'data': [
        { key: "Week Name Yesterday", value: "Yesterday" },
        { key: "Week Name Today", value: "Today" },
        { key: "Week Name Tomorrow", value: "Tomorrow" },
        { key: "Week Name Start Day", value: "Week Start Day" },
        { key: "Week Name End Day", value: "Week End Day" },
      ],
      'input_type': 'Dropdown'
    }
  ];


  public dataset_dataview_map = {
    'edit': 0,
    'view': 1,
  }

  public shareable_dashboard_config = {
    dshb_link_expiry: 10,// in minutes
    auto_play_interval: 10,// in seconds
    allow_shareable_dashboard: false
  }

  public service_email = "info@leggero.ai";

  public appVariant='raptor'

  public track_user_activity = true;  
  public platform = 'raptor';   
  public token_key = 'token';   


  constructor () {}
}

